import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgMeterkastGroepen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F170B8"
      d="M32 7H12v26h20z"
    />
    <path
      fill="#F8BADD"
      d="M31 8H13v24h18z"
    />
    <path
      fill="#F170B8"
      d="m9 35 2-2V7L9 5z"
    />
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="M22.25 9 20 12.56h1.72V15L24 11.42h-1.75z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M16.5 29v-9.08h1V29z"
      clipRule="evenodd"
    />
    <path
      fill="#F170B8"
      d="M18.5 17.5h-3v3h3z"
    />
    <path
      fill="#F170B8"
      d="M18 18v2h-2v-2zm1-1h-4v4h4zM12 12h-1v4h1zM12 24h-1v4h1z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M21.5 29v-9.08h1V29z"
      clipRule="evenodd"
    />
    <path
      fill="#F170B8"
      d="M23.5 17.5h-3v3h3z"
    />
    <path
      fill="#F170B8"
      d="M23 18v2h-2v-2zm1-1h-4v4h4zM24 29h-4v1h4z"
    />
    <path
      fill="#F170B8"
      d="M24 29h-4v1h4zM19 29h-4v1h4z"
    />
    <path
      fill="#F170B8"
      d="M19 29h-4v1h4z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M26.5 29v-9.08h1V29z"
      clipRule="evenodd"
    />
    <path
      fill="#F170B8"
      d="M28.5 26.5h-3v3h3z"
    />
    <path
      fill="#F170B8"
      d="M28 27v2h-2v-2zm1-1h-4v4h4z"
    />
    <path
      fill="#F8BADD"
      d="M9 5H8v30h1z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgMeterkastGroepen);

export default ForwardRef;
